import { NgModule }                         from '@angular/core';
import { CommonModule }                     from '@angular/common';
import { RouterModule }                     from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PaymentPackageComponent } from './payment-package/payment-package.component';

import { SharedModule }          from '../shared.module';
import { PaymentTableComponent } from './payment-table/payment-table.component';
import { PaymentComponent }      from './payment.component';


@NgModule({
  declarations: [
    PaymentPackageComponent,
    PaymentTableComponent,
    PaymentComponent,
  ],
  imports:      [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports:      [
    PaymentPackageComponent,
    PaymentTableComponent,
    PaymentComponent
  ],
})
export class PaymentModule {}
